import { TextField } from "@mui/material";
import i18next from "i18next";
import React, { useEffect } from "react";

import { useNavigate } from "react-router";
import Button from "../../components/Button";
import Label from "../../components/Label";
import Loader from "../../components/Loader";
import SimpleDialog from "../../components/SimpleDialog";
import Table from "../../components/Table";
import * as basinsServices from "../../services/basinsServices";
import { constants, routes, utils } from "../../utils";

type Params = { search: string; skip: number; limit: number };

const columns = ["name"];

export default function BasinsList() {
	const [data, setData] = React.useState<any>({ result: [], total: 0 });
	const [params, setParams] = React.useState<Params>({ search: "", skip: 0, limit: constants.DEFAULT_PAGE_SIZE });
	const [loading, setLoading] = React.useState<boolean>(false);

	const navigate = useNavigate();

	const goBack = () => navigate("/", { replace: true });

	useEffect(() => {
		getBasins(params);
	}, []);

	const getBasins = async (newParms: Params) => {
		setLoading(true);
		const response = await basinsServices.search(newParms);
		setData(response);
		setLoading(false);
	};

	const handleUpdate = (options: any) => {
		getBasins({ ...params, ...options });
	};

	const handleChangeSearch = utils.debounce((e) => {
		var newParms = params;
		newParms = { ...params, search: e.target.value };

		getBasins(newParms);
		setParams({ ...newParms });
	}, constants.DEBOUNCE_TIME);

	return (
		<SimpleDialog open={true} onClose={goBack}>
			<Label isTitle text={i18next.t("basins")} />
			<Table
				onRowPress={(basin) => navigate(routes.BASIN(basin.id))}
				keyExtractor={(row) => row.id}
				columns={columns}
				rows={data.result}
				total={data.total}
				handleUpdate={handleUpdate}
				filtersComponents={
					<div className="d-flex align-items-center my-3">
						<TextField
							size="small"
							placeholder={i18next.t("search")}
							inputProps={{ "data-testid": "search-input" }}
							onChange={handleChangeSearch}
						/>
					</div>
				}
			/>
			<div className="d-flex mt-4 justify-content-between">
				{loading ? <Loader /> : <div />}
				<Button
					label={i18next.t("go-back")}
					secondary
					onClick={() => navigate(routes.DASHBOARD)}
					className="ms-4"
					datatestid="cancel"
				/>
			</div>
		</SimpleDialog>
	);
}
